/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import styles from './BreakdownChart.module.scss';

import numeral from 'numeral';
import PropTypes from 'prop-types';
import React from 'react';

const BreakdownChart = ({
  size,
  strokewidth,
  value,
  showlblFirstLegend,
  lblFirstLegendPercent,
  showlblSecondLegend,
  lblSecondLegendPercent
}) => {
  const halfsize = (size * 0.5);
  const radius = halfsize - (strokewidth * 0.5);
  const circumference = 2 * Math.PI * radius;
  const strokeval = ((Math.trunc(lblFirstLegendPercent * 100 ) * circumference) / 100);
  const dashval = (strokeval + ' ' + circumference);

  const trackstyle = {strokeWidth: strokewidth};
  const indicatorstyle = {strokeWidth: strokewidth, strokeDasharray: dashval};
  const rotateval = 'rotate(-90 '+halfsize+','+halfsize+')';

  const lblFirstLegendPercentChart = numeral(lblFirstLegendPercent).format('0%');
  const lblSecondLegendPercentChart = numeral(lblSecondLegendPercent).format('0%');

  const lblFirstLegendLabel = showlblFirstLegend ? <p className={styles["lblFirstLegend"]}>{lblFirstLegendPercentChart} Amount Distributed YTD</p> : null;
  const lblSecondLegendLabel = showlblSecondLegend ? <p className={styles["lblSecondLegend"]}>{lblSecondLegendPercentChart} Remaining RMD</p> : null;

  return (
    <div id="breakdown-chart" className={styles["breakdown-chart"]}>
      <svg className={styles["donutchart"]} width={size} height={size}>
        <circle className={styles["donutchart-track"]} r={radius} cx={halfsize} cy={halfsize} transform={rotateval} style={trackstyle}/>
        <circle className={styles["donutchart-indicator"]} r={radius} cx={halfsize} cy={halfsize} transform={rotateval} style={indicatorstyle}/>
      </svg>
      <div className={styles["legend"]}>
        {lblFirstLegendLabel}
        {lblSecondLegendLabel}
      </div>
    </div>
  );
};

BreakdownChart.propTypes = {
  size: PropTypes.number,
  strokewidth: PropTypes.number,
  showlblFirstLegend: PropTypes.bool,
  lblFirstLegendPercent: PropTypes.number,
  showlblSecondLegend: PropTypes.bool,
  lblSecondLegendPercent: PropTypes.number
};

BreakdownChart.defaultProps = {
  lblFirstLegendPercent: 0.00,
  lblSecondLegendPercent: 0.00,
  size:81,
  strokewidth:15
};

export default BreakdownChart;